import React, { useEffect } from "react";

export function usePersistedState<T>(
  key: string,
  defaultValue?: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = React.useState<T>(() => {
    const localStorageValue = localStorage.getItem(key);
    if (!localStorageValue) return defaultValue;
    try {
      return JSON.parse(localStorageValue) || defaultValue;
    } catch (e) {
      console.warn(e);
      return defaultValue;
    }
  });
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);
  return [state, setState];
}
